export default __webpack_public_path__ + "static/media/ZK830.04f4470b.pdf";